import { useState, useEffect } from 'react';
import firebase from 'firebase/app';
import 'firebase/firestore'; // IMPORTANT if not already imported elsewhere

export function useClientConnectedAccounts(clientId) {
  const [connectedAccounts, setConnectedAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!clientId) {
      setConnectedAccounts([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const db = firebase.firestore();
    const ref = db.collection('clients').doc(clientId).collection('connected-accounts');

    const unsubscribe = ref.onSnapshot(
      (snapshot) => {
        const items = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
        setConnectedAccounts(items);
        setLoading(false);
      },
      (err) => {
        console.error('connected-accounts snapshot error:', err);
        setError(err);
        setConnectedAccounts([]);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [clientId]);

  return [loading, connectedAccounts, error];
}
